// extracted by mini-css-extract-plugin
module.exports = {"mobile":"900px","tablet":"1000px","laptop":"1200px","desktop":"1440px","xl":"1800px","blackDark":"#080808","black":"#141414","white":"#f9f7f7","singleGalleryGap":"25px"};